
import React from 'react';

import { AsiteDocumentsSyncClientLogDto } from '../../../../../swagger';
import api from '../../../../../libs/api';
import { useQuery } from 'react-query';
import { configQueryReactCodetable } from '../../../../../Hooks';


const fetchDocumentFindingStatus = async () => await api.get('/api/v2/AsiteRelaticsSync/GetAllAsiteDocumentsSyncClientLog', { safe: true });

const useDocumentFindingStatusQuery = (setData: React.Dispatch<React.SetStateAction<AsiteDocumentsSyncClientLogDto[]>>) => {
    const documentFindingStatus = useQuery('review-document-finding-status', fetchDocumentFindingStatus, {
        ...configQueryReactCodetable,
        onSuccess: (result: AsiteDocumentsSyncClientLogDto[]) => {
            setData(result)
        }
    });

    return documentFindingStatus;
};


const useRelaticsRealTimeLogDialog = (data: AsiteDocumentsSyncClientLogDto[], setData: React.Dispatch<React.SetStateAction<AsiteDocumentsSyncClientLogDto[]>>) => {

    const query = useDocumentFindingStatusQuery(setData);

    return { query };

};


export default useRelaticsRealTimeLogDialog;